import SecureLS from "secure-ls";
export default new SecureLS({ isCompression: false });
